import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/HomeView.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/home",
    name: "home",
    component: HomeView,
  },
  {
    path: "/",
    redirect: "/home",
  },
  {
    path: "/menu/:id",
    name: "menu",
    component: () => import("../views/MenuView.vue"),
  },

  {
    path: "/admin",
    component: () => import("../views/AdminView.vue"),
    redirect: "/admin/editar-platillo",
    children: [
      {
        path: "agregar-platillo",
        name: "agregarPlatillo",
        component: () => import("@/components/admin/AgregarNuevo.vue"),
      },
      {
        path: "editar-platillo",
        name: "editarPlatillo",
        component: () => import("@/components/admin/EditarPlatillo.vue"),
      },
    ],
  },
  {
    path: "/login",
    name: "AuthView",
    component: () => import("../views/AuthView.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
